import { TEASER_MARKET } from 'consts/app';
import {
  BetModel,
  FutureBetModel,
  addBet,
  addFutureBet,
  removeBet,
  removeFutureBet,
} from 'features/home/homeSlice';
import { FutureOddModel, OddModel } from 'models';
import { addTeasers, removeTeaser } from 'redux/teaserSlice';

const handleOddClick = (
  odd: OddModel,
  bets: BetModel[],
  dispatch: any,
  homeTeam: string,
  awayTeam: string,
  gameId: string,
  category: string,
  gameStatus: string,
  homeTeamLogo?: string,
  awayTeamLogo?: string,
) => {
  if (bets.findIndex((bet) => bet.odd.id === odd.id) !== -1) {
    dispatch(removeBet(odd.id));
  } else {
    dispatch(
      addBet({
        odd,
        homeTeam,
        awayTeam,
        category,
        gameId,
        singleAmount: 0,
        homeTeamLogo: homeTeamLogo ?? '',
        awayTeamLogo: awayTeamLogo ?? '',
        gameStatus,
      }),
    );
  }
};

const handleOddTeaserClick = (
  odd: OddModel,
  teasers: BetModel[],
  dispatch: any,
  homeTeam: string,
  awayTeam: string,
  gameId: string,
  category: string,
  gameStatus: string,
  homeTeamLogo?: string,
  awayTeamLogo?: string,
) => {
  if (teasers.findIndex((bet) => bet.odd.id === odd.id) !== -1) {
    dispatch(removeTeaser(odd.id));
  } else {
    if (category === 'football' && TEASER_MARKET.includes(odd.market)) {
      dispatch(
        addTeasers({
          odd,
          homeTeam,
          awayTeam,
          category,
          gameId,
          singleAmount: 0,
          homeTeamLogo: homeTeamLogo ?? '',
          awayTeamLogo: awayTeamLogo ?? '',
          gameStatus,
        }),
      );
    }
  }
};

const handleFutureBetClick = (
  odd: FutureOddModel,
  futureBets: FutureBetModel[],
  dispatch: any,
  team: string,
  futureId: string,
  category: string,
  league: string,
) => {
  if (futureBets.findIndex((bet) => bet.odd.id === odd.id) !== -1) {
    dispatch(removeFutureBet(odd.id));
  } else {
    dispatch(
      addFutureBet({
        odd,
        team,
        category,
        futureId,
        league: league,
        singleAmount: 0,
      }),
    );
  }
};

export { handleOddClick, handleFutureBetClick, handleOddTeaserClick };
